
<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header border-bottom-0px text-align-center">

        <div class="row ">
          <div class="col-md-12 text-align-center">
            <label class="label-size-2 font-color-secondary ">IVF Cycle Summary Report</label>
          </div>

        </div>

      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Egg Source Details</label>
          </div>
        </div>
        <div class="row">

          <div class="col-md-3 padding-left-20px">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3">Source: SELF</label>
            </div>

          </div>
          <div class="col-md-3">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">LMP Date: 17-10-2019</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f3 font-weight-normal">LMP Cycle: REGLR</label>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Baseline:</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">No Data To Display</label>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Follicular Growth Details:</label>
          </div>
        </div>
        <div class="table-component">
          <div class="table-responsive overflow-x-hidden">

            <table class="table table-striped margin-left-zero pgbreak">

              <thead class="">
                <tr>

                  <th class="">Doc&Date</th>

                  <th class="">Endo Thickness</th>

                  <th class="">Medicines & Tests</th>
                  <th class="">Ovaries</th>
                  <th class="">Comments</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr>
                  <td>06<br />17 OCT 2019</td>
                  <td>8</td>

                  <td class="">

                    Medicines: <br />
                    Tests: <br />
                    FOLLICULAR GROWTH SCAN()

                  </td>

                  <td class="">

                    Left: 2(10),1(12),1(13)<br />
                    Right:3(10),2(12),1(13)


                  </td>
                  <td></td>


                </tr>

              </tbody>

            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Pickup Details</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Ovulation Trigger:</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Surgeon: Employee-89</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Asst.Surgeon: Employee-91</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Anaesthesia: IVS</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Anaesthesiologist: Employee-89</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Pickup Planned at: 17 OCT 2019 10:30:00 AM</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Pickup Actual at:</label>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Follicles Size for Pickup:</label>
          </div>
        </div>
        <div class="table-component">
          <div class="table-responsive">


            <table class="table table-striped margin-left-zero width-50-new">

              <tr>

                <th class="font-weight-normal td-padding-tb background-primary">

                </th>

                <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                  Right Ovary
                </th>

                <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                  Left Ovary
                </th>

              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  No. Of Follicles
                </th>
                <td class="td-padding-tb">
                  
                </td>
                <td class="td-padding-tb">
                  
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  No. Of Follicles Aspirated
                </th>
                <td class="td-padding-tb">
                  
                </td>
                <td class="td-padding-tb">
                
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  No. Of Follicles Retrieved
                </th>
                <td class="td-padding-tb">
                  
                </td>
                <td class="td-padding-tb">
                  
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="td-padding-tb background-primary">
                  Total No. Of Oocytes
                </th>
                <td class="td-padding-tb font-weight-bold">
                  
                </td>
                <td class="td-padding-tb font-weight-bold">
                  
                </td>
              </tr>
            </table>

          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Needle Used: Single Lumen</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Route: TV</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Complications: Nill</label>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Oocyte Quality:</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Total Oocytes: 22</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Frozen Oocytes: </label>
        </div>
        <div class="table-component">
          <div class="table-responsive">


            <table class="table table-striped margin-left-zero width-50-new">

              <tr>

                <th class="font-weight-normal td-padding-tb background-primary">

                </th>

                <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                  OCC
                </th>

                <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                  Denuded
                </th>

              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  Mature
                </th>
                <td class="td-padding-tb">
                  
                </td>
                <td class="td-padding-tb">
                  
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  GV
                </th>
                <td class="td-padding-tb">
                  
                </td>
                <td class="td-padding-tb">
                  
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  MI
                </th>
                <td class="td-padding-tb">
                 
                </td>
                <td class="td-padding-tb">
                  
                </td>
              </tr>
              <tr>
                <th rowspan="1" class="td-padding-tb background-primary">
                  MII
                </th>
                <td class="td-padding-tb font-weight-bold">
                  
                </td>
                <td class="td-padding-tb font-weight-bold">
                 
                </td>
              </tr>
            </table>

          </div>
        </div>
      
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Sperm Source Details</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Fresh/Frozen: Fresh </label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Husband/Donor: Husband </label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Retrieval: EJAC </label>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Procedure:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">ICSI</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Performed By: Dr.Employee-89</label>
        </div>
        <div class="row margin-left-0px">
          <label class="margin-bottom-0px f3">Details: Others</label>
        </div>
        <div class="row margin-left-0px pgbreak">
          <label class="margin-bottom-0px f3">Remarks: Oligospermia</label>
        </div>
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Semen Data Analysis</label>
          </div>
        </div>
        <div class="table-component">
          <div class="table-responsive">
            <table class="table table-striped margin-left-zero width-50-new">
              <tr>

                <th class="font-weight-normal td-padding-tb background-primary">

                </th>

                <th class="font-weight-normal td-padding-tb background-primary">
                  (Day1)
                </th>
                <th class="font-weight-normal td-padding-tb background-primary">

                </th>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">

                </th>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  Pre-Wash
                </th>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  Post-Wash
                </th>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Volume(ml)
                </td>
                <td class="td-padding-tb">
                  2.5
                </td>
                <td class="td-padding-tb">
                  0.5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  60
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Active Progressive Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  10
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Cellular Debris(mil/ml)
                </td>
                <td class="td-padding-tb">
                  ++
                </td>
                <td class="td-padding-tb">
                  ++
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Method of Preperation
                </td>
                <td class="td-padding-tb">
                  DG
                </td>
                <td class="td-padding-tb">
                  DG
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Incubation Time(In Min)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  45
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motile Sperm Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  60
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Notes
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Side Observed
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Catheter Load Time
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Catheter Loaded By
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>



